// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZrmWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerAccountViewZrmWebApiHandler_inquiries,
  RentalManagerAccountViewZrmWebApiHandler_inquiries_Path,
  RentalManagerAccountViewZrmWebApiHandler_leases,
  RentalManagerAccountViewZrmWebApiHandler_leases_Path,
  RentalManagerAccountViewZrmWebApiHandler_list,
  RentalManagerAccountViewZrmWebApiHandler_list_Path,
  RentalManagerAccountViewZrmWebApiHandler_payments,
  RentalManagerAccountViewZrmWebApiHandler_payments_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  AccountViewListingsDto,
  AccountViewTableCellDto,
  ListingAlias,
} from '@zg-rentals/ts-rental-manager-api-client';

interface InquiriesParams {
  listingAlias: ListingAlias;
}
interface LeasesParams {
  listingAlias: ListingAlias;
}
interface ListParams {
  includeActive?: boolean;
  includeArchived?: boolean;
  includeInactive?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  offset?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface PaymentsParams {
  listingAlias: ListingAlias;
}

export type RentalManagerAccountViewZrmWebApiHandler_inquiries_Options = UseQueryOptions<
  AccountViewTableCellDto,
  unknown,
  AccountViewTableCellDto,
  Array<string | InquiriesParams>
>;

const RentalManagerAccountViewZrmWebApiHandler_inquiries_GetKey = (getParams: InquiriesParams) => [
  RentalManagerAccountViewZrmWebApiHandler_inquiries_Path,
  getParams,
];

/**
 * Get zrm user account view property inquiries status
 */
export const useRentalManagerAccountViewZrmWebApiHandler_inquiries = (
  getParams: InquiriesParams,
  options: Omit<RentalManagerAccountViewZrmWebApiHandler_inquiries_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZrmWebApiHandler_inquiries_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmWebApiHandler_inquiries(getParams),
  });
};
useRentalManagerAccountViewZrmWebApiHandler_inquiries.getKey =
  RentalManagerAccountViewZrmWebApiHandler_inquiries_GetKey;

export type RentalManagerAccountViewZrmWebApiHandler_leases_Options = UseQueryOptions<
  AccountViewTableCellDto,
  unknown,
  AccountViewTableCellDto,
  Array<string | LeasesParams>
>;

const RentalManagerAccountViewZrmWebApiHandler_leases_GetKey = (getParams: LeasesParams) => [
  RentalManagerAccountViewZrmWebApiHandler_leases_Path,
  getParams,
];

/**
 * Get zrm user account view property leases status
 */
export const useRentalManagerAccountViewZrmWebApiHandler_leases = (
  getParams: LeasesParams,
  options: Omit<RentalManagerAccountViewZrmWebApiHandler_leases_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZrmWebApiHandler_leases_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmWebApiHandler_leases(getParams),
  });
};
useRentalManagerAccountViewZrmWebApiHandler_leases.getKey = RentalManagerAccountViewZrmWebApiHandler_leases_GetKey;

export type RentalManagerAccountViewZrmWebApiHandler_list_Options = UseQueryOptions<
  AccountViewListingsDto,
  unknown,
  AccountViewListingsDto,
  Array<string | ListParams>
>;

const RentalManagerAccountViewZrmWebApiHandler_list_GetKey = (getParams: ListParams) => [
  RentalManagerAccountViewZrmWebApiHandler_list_Path,
  getParams,
];

/**
 * Get zrm user account view property list
 */
export const useRentalManagerAccountViewZrmWebApiHandler_list = (
  getParams: ListParams,
  options: Omit<RentalManagerAccountViewZrmWebApiHandler_list_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZrmWebApiHandler_list_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmWebApiHandler_list(getParams),
  });
};
useRentalManagerAccountViewZrmWebApiHandler_list.getKey = RentalManagerAccountViewZrmWebApiHandler_list_GetKey;

export type RentalManagerAccountViewZrmWebApiHandler_payments_Options = UseQueryOptions<
  AccountViewTableCellDto,
  unknown,
  AccountViewTableCellDto,
  Array<string | PaymentsParams>
>;

const RentalManagerAccountViewZrmWebApiHandler_payments_GetKey = (getParams: PaymentsParams) => [
  RentalManagerAccountViewZrmWebApiHandler_payments_Path,
  getParams,
];

/**
 * Get zrm user account view property payments status
 */
export const useRentalManagerAccountViewZrmWebApiHandler_payments = (
  getParams: PaymentsParams,
  options: Omit<RentalManagerAccountViewZrmWebApiHandler_payments_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerAccountViewZrmWebApiHandler_payments_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmWebApiHandler_payments(getParams),
  });
};
useRentalManagerAccountViewZrmWebApiHandler_payments.getKey = RentalManagerAccountViewZrmWebApiHandler_payments_GetKey;
